import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './app.vue';
import router from './router';
import TNPlugin from '@life_uikit/uikit';
import VueApexCharts from 'vue3-apexcharts';

// Порядок CSS-импортов критичен (см. UI_DESIGN_GUIDE §2):
import '@life_uikit/uikit/variables.css';       // светлые семантические токены
import '@life_uikit/uikit/variables-dark.css';  // .tn-dark-theme переопределения токенов
import '@life_uikit/uikit/fonts.css';           // @font-face Proxima Nova
import '@/app.css';                              // reset + базовые --zk-* токены
import '@/assets/css/zk-ui.css';                // утилитарный слой вёрстки
import '@/assets/css/zk-dark.css';              // тёмная тема утилитарного слоя
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';

import { setDarkTheme } from '@life_uikit/uikit/helpers';
import LifeBridge from '@tnlife/tn-bridge';
import { useAuthStore } from '@/stores/auth';

// Тему присылает TN Life событием colorSchemeUpdated; в standalone — localStorage.
LifeBridge.addEventListener('colorSchemeUpdated', setDarkTheme);

// TN Life накладывает системные пилюли («⋯» и «✕») поверх правого верхнего
// угла мини-аппа В ОБОИХ режимах: мобильный WebView — нативно, web-суперап —
// прячет свою шапку после инициализации iframe и оставляет плавающие кнопки
// (проверено на web.tn-life-stable: контейнер шапки уходит в v-if=false).
// Safe-area API у моста нет — по классу на body app.css резервирует верхнюю
// полосу, а топбар «Опросы» занимает её (см. page-layout/TheTopbar).
if (LifeBridge.isWebView || LifeBridge.isIFrame) {
  document.body.classList.add('is-tn-miniapp');
}

async function initLifeBridge(): Promise<void> {
  if (!LifeBridge.isWebView && !LifeBridge.isIFrame) return;

  // У моста нет таймаута: если хост не ответит, промис повиснет навсегда и
  // app.mount (в finally цепочки) не выполнится — вечный белый экран.
  // Ждём хоста не дольше 2 секунд, дальше поднимаемся как обычно.
  const response = await Promise.race([
    LifeBridge.send('LifeMiniAppInit', {}),
    new Promise((resolve) => setTimeout(() => resolve(null), 2000)),
  ]);
  if (!response) {
    console.warn('TN Life host did not answer LifeMiniAppInit in 2s');
    return;
  }
  const colorScheme = (response as any)?.data?.colorScheme;
  if (colorScheme === 'dark' || colorScheme === 'light') {
    setDarkTheme(colorScheme);
  }
}

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(TNPlugin);
app.use(VueApexCharts);

// Сначала auth, затем mount. Если auth упал — всё равно монтируем (мягкая деградация).
const authStore = useAuthStore();
initLifeBridge()
  .catch((e) => console.warn('TN Life init error:', e))
  .then(() => authStore.bootstrapAuth())
  .catch((e) => console.warn('auth bootstrap error:', e))
  .finally(() => app.mount('#app'));
